<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.sex_place')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="sex">
			<van-radio-group v-model="radio">
				<div class="item van-hairline--bottom" @click="save(1)">
					<van-radio name="1">{{$t("setting.man")}}</van-radio>
				</div>
				<div class="item van-hairline--bottom" @click="save(2)">
					<van-radio name="2">{{$t("setting.female")}}</van-radio>
				</div>
			</van-radio-group>

		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				radio: "",
				userInfo: {}
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			save(gender) {
				this.$http({
					method: 'post',
					data: {
						gender
					},
					url: 'profile'
				}).then(res => {
					if (res.code == 1) {
						this.getUserInfo();
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code == 1) {
						this.radio = res.data.gender+'';
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},
		
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .sex {
		background-color: #fff;
		padding: 0 40px;
	}

	.container .sex .item {
		font-size: 35px;
		line-height: 50px;
		padding: 30px 0;
	}

	::v-deep .van-radio__label {
		line-height: 50px;
		margin-left: 30px;
	}

	::v-deep .van-radio__icon {
		font-size: 30px;
	}

	::v-deep .van-radio__icon--checked .van-icon {
		color: #fff;
		border-color: rgb(126, 86, 120);
		background-color: rgb(126, 86, 120);
	}

	.container .van-hairline--bottom::after {
		border-bottom-width: 3px;
	}
</style>